import React from 'react'
import ReactDOM from 'react-dom'
import 'antd/dist/antd.min.css'
import './index.css'
// import registerServiceWorker from './registerServiceWorker'

import App from './board/App'
ReactDOM.render(<App />, document.getElementById('root'))

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js